import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import ProfileImage from '../../../app-bar/profile-image';
import { updateProps, submitPost } from '../../../../stores/newsfeed/actions';
import { Card, CardActions } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import PhotoIcon from 'material-ui/svg-icons/editor/insert-photo';
import Category from './category';
import Locations from './locations';
import Message from './message';
import UploadFiles from './uploadFiles';
import UploadFromMM from './uploadFromMM';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const propTypes = {
  profileImageUrl: PropTypes.string,
  companyName: PropTypes.string,
  email: PropTypes.string,
  updateProp: PropTypes.func,
  newsfeedReducer: PropTypes.object,
  savePost: PropTypes.func,
  locations: PropTypes.array,
  MMFiles: PropTypes.array,
};

class NewPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subCategoryExpanded: false,
      locExpanded: false,
      category: 'general',
      addFilesExpanded: false,
      errors: [],
      messageExpanded: true,
      uploadFromMMExpanded: false,
    };
  }

  componentWillMount() {
    const { locations, updateProp } = this.props;
    if (R.propEq('length', 1, locations)) {
      updateProp({
        selectedLocations: [{ locationId: R.pathOr('', [0, '_id'], locations), name: R.pathOr('', [0, 'property_name'], locations) }],
        corporateLocSelected: true,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  componentWillUnmount() {
    this.clearStore();
  }

  clearStore = () => {
    const initialState = {
      subCategoryExpanded: false,
      locExpanded: false,
      category: 'Updates',
      addFilesExpanded: false,
      messageExpanded: true,
      errors: [],
    };
    const initialReducer = {
      showNewPostDialog: false,
      postMessage: '',
      selectedFiles: [],
      selectedMainCategory: 'Updates',
      selectedSubCategory: '',
      selectedHashtags: [],
    };
    if (!R.propEq('length', 1, this.props.locations)) {
      initialReducer.corporateLocSelected = false;
      initialReducer.selectedLocations = [];
    }
    this.setState(initialState);
    this.props.updateProp(initialReducer);
  };

  toggleUploadFiles = () => {
    this.setState({ addFilesExpanded: !this.state.addFilesExpanded, locExpanded: false, subCategoryExpanded: false, messageExpanded: false, uploadFromMMExpanded: false });
    setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
  };

  displayErrorMsg = () => {
    const { locations } = this.props;
    const { selectedLocations, postMessage, selectedSubCategory, uploadingFile } = this.props.newsfeedReducer;
    const errors = [];
    if (isNilOrEmpty(selectedSubCategory)) errors.push('Please select a category.');
    if (isNilOrEmpty(selectedLocations) && R.propOr(0, 'length', locations) > 1) errors.push('Please select which locations this post applies to.');
    if (!postMessage) errors.push('Please enter a message.');
    if (uploadingFile) errors.push('Please wait for all files to finish uploading.');
    this.setState({ errors });
  };

  render() {
    const {
      companyName,
      email,
      locations,
      MMFiles,
      newsfeedReducer,
      profileImageUrl,
      savePost,
      updateProp,
    } = this.props;

    const { selectedLocations, postMessage, selectedSubCategory, uploadingFile } = newsfeedReducer;
    const postContentComplete = !isNilOrEmpty(selectedLocations) && postMessage && !isNilOrEmpty(selectedSubCategory) && !uploadingFile;
    const selectedFilesNotFromMM = newsfeedReducer.selectedFiles.filter(file => !R.contains('tags', R.keys(file)));

    return (
      <Card style={{ width: '89%', margin: '0 0 2% 11%' }}>
        <div>
          <div style={{ float: 'left', width: '50px', padding: '1% 2%' }}>
            <ProfileImage
              className="profile-link-image"
              companySlugName={companyName || email}
              imageUrl={profileImageUrl}
              style={{ border: '0.5px solid #D3D3D3' }}
            />
          </div>
          <div style={{
            float: 'left',
            color: 'rgba(0, 0, 0, 0.54)',
            fontSize: '16px',
            padding: '16px 2%',
            width: 'calc(100% - 50px)',
            overflowY: 'hidden',
            overflowX: 'hidden',
            fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" }}
          >
            Post a new message or announcement
          </div>
        </div>
        {
          isNilOrEmpty(locations) ?
            (
              <div style={{ padding: '64px', textAlign: 'center' }}>
                In order to create a post, please <a style={{ cursor: 'pointer' }} onClick={() => {
                  // Ghetto solution, in case user finished profile, but the locations aren't updated to userReducer.
                  // TODO: will fix when we redo profile
                  window.location = '/profile';
                }}
                >complete your profile</a>.
              </div>
            ) : (
              <div>
                { !isNilOrEmpty(this.state.errors) &&
                  <div style={{ color: 'red', padding: '8px' }}>
                    {this.state.errors.map((error, i) => (<span key={i}>{error}<br/></span>))}
                  </div> }
                <Category
                  onCardExpand={() => this.setState({ subCategoryExpanded: !this.state.subCategoryExpanded, locExpanded: false, addFilesExpanded: false, uploadFromMMExpanded: false })}
                  expanded={this.state.subCategoryExpanded}
                  mainCategorySelect={(value) => {
                    updateProp({ selectedMainCategory: value });
                    this.setState({ subCategoryExpanded: true });
                  }}
                  subCategorySelect={(value, hashtag) => updateProp({ selectedSubCategory: value, subCategoryHash: hashtag })}
                />
                {
                  R.propOr(0, 'length', locations) > 1 &&
                    <Locations
                      expanded={this.state.locExpanded}
                      onCardExpand={() => this.setState({ locExpanded: !this.state.locExpanded, addFilesExpanded: false, subCategoryExpanded: false, uploadFromMMExpanded: false })}
                    />
                }
                {
                  !isNilOrEmpty(MMFiles) &&
                    <UploadFromMM
                      onCardExpand={(newExpandedState) => this.setState({ locExpanded: false, addFilesExpanded: false, subCategoryExpanded: false, uploadFromMMExpanded: newExpandedState })}
                      onChangeSelection={(selectedFiles) => updateProp({ selectedFiles })}
                      savingPost={newsfeedReducer.savingPost}
                    />
                }
                <Message
                  closeExpandedArea={() => this.setState({ locExpanded: false, addFilesExpanded: false, subCategoryExpanded: false, uploadFromMMExpanded: false })}
                  expanded={this.state.messageExpanded}
                  onCardExpand={() => this.setState({ messageExpanded: true, locExpanded: false, addFilesExpanded: false, subCategoryExpanded: false, uploadFromMMExpanded: false })}
                />
                {
                  this.state.addFilesExpanded ? (<UploadFiles
                    expanded={this.state.addFilesExpanded}
                    onCardExpand={this.toggleUploadFiles}
                    selectedFilesNotFromMM={selectedFilesNotFromMM}
                  />) : <span/>
                }
              </div>
          )
        }
        <CardActions>
          <div style={{ display: 'inline-block', width: '100%' }}>
            {
              (!isNilOrEmpty(locations) && !this.state.addFilesExpanded) && (
                <FlatButton
                  onTouchTap={this.toggleUploadFiles}
                  label={R.isEmpty(newsfeedReducer.selectedFiles) || selectedFilesNotFromMM.length === 0 ? 'Upload Files' : `Upload Files (${R.prop('length', selectedFilesNotFromMM)} Uploaded)`}
                  secondary
                  icon={<PhotoIcon color={'rgb(0, 188, 212)'} />}
                  disabled={newsfeedReducer.savingPost}
                  style={{ float: 'left', display: 'inline-block' }}
                />
              )
            }
            <div style={{ float: 'right', display: 'inline-block' }}>
              <FlatButton
                label="Cancel"
                primary
                onTouchTap={this.clearStore}
                disabled={newsfeedReducer.savingPost}
              />
              {
                !isNilOrEmpty(locations) && (
                  <FlatButton
                    label="Post"
                    loader={newsfeedReducer.savingPost}
                    secondary
                    onTouchTap={() => {
                      if (postContentComplete) {
                        savePost();
                        this.clearStore();
                      } else {
                        this.displayErrorMsg();
                      }
                    }}
                  />
                )
              }
            </div>
          </div>
        </CardActions>
      </Card>
    );
  }
}

NewPost.propTypes = propTypes;

const mapStateToProps = ({ user, newsfeed, profile }) => ({
  profileImageUrl: user.getIn(['company', 'profileImageUrl']),
  companyName: user.getIn(['company', 'companyName']),
  email: user.getIn(['user', 'email']),
  locations: user.get('mrLocations'),
  newsfeedReducer: newsfeed.toJS(),
  MMFiles: (profile.get('media')) ? profile.get('media').toJS() : [],
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
  savePost: (...args) => dispatch(submitPost(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewPost);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/newPost/container.jsx